import { Grid, Typography, Divider } from "@mui/material";
import Seccion_Items from "../Seccion_Items";

const Seccion_ConoGratis_Dashboard = () => {
    return (
        <Grid container justifyContent={'center'} alignItems={'center'} size={{ xs: 12 }}>

            <Seccion_Items
                coleccion="cono-titulo-principal"
                titulo="Subir imagen título principal"
                mostrarEditar={true}
            />

            <Divider sx={{ width: '100%', my: 3 }} />

            <Seccion_Items
                coleccion="cono-titulo-clientes"
                titulo="Subir imagen título clientes"
                mostrarEditar={true}
            />

            <Divider sx={{ width: '100%', my: 3 }} />

            {/* 👇 Nueva sección pista */}
            <Seccion_Items
                coleccion="cono-pista"
                titulo='Subir media para "Mira esta pista" (imagen, gif o video)'
                mostrarEditar={false}
            />

        </Grid>
    );
};

export default Seccion_ConoGratis_Dashboard;